import { usePageTitle } from '../../hooks/usePageTitle'
import DataToResult from './_components/DataToResult'
import FilterSection from './_components/FilterSection'
import { Container } from './style'
import { PageProps } from '@/@types/global'

const SearchReportOrders: React.FC<PageProps> = ({ title, subtitle }) => {
  usePageTitle({ title, subtitle })

  return (
    <Container>
      <FilterSection />
      <DataToResult />
    </Container>
  )
}

export default SearchReportOrders
